import React, { useState } from 'react';
import { IconButton } from './Button';
import FaIcon from './FaIcon';
import Share from './Share';
import { useGlobalModal } from '../contexts/ModalContext';
import { useMilestones, milestoneAnalytics } from '../contexts/MilestoneContext';
import { logEvent } from '../analytics';
import { celebrationEventName, celebrationTheme, dailyCircuitCopy, MILESTONE_LABELS, MILESTONE_SHARE_LABEL, milestoneHeadline, milestoneNumber, milestoneShareText, milestoneShareUrl } from '../utils/milestones';
import styles from '../styles/MilestoneCelebration.module.css';

const ICONS = { streak: 'fa-solid fa-fire', stelline: 'fa-solid fa-star', learned_terms: 'fa-solid fa-learning-books', daily_circuit: 'fa-solid fa-trophy' };
const MilestoneCelebration = ({ event }) => {
  const { closeModal } = useGlobalModal();
  const { pending } = useMilestones();
  const [showShareOptions, setShowShareOptions] = useState(false);
  const file = pending.find((item) => item.event.id === event.id)?.file;
  const shareText = milestoneShareText(event);
  const theme = celebrationTheme(event);
  const isCircuit = event.kind === 'daily_circuit';
  const { achievement, caption } = isCircuit ? dailyCircuitCopy(event)
    : { achievement: milestoneNumber(event), caption: MILESTONE_LABELS[theme] };
  const headline = isCircuit ? `${achievement} — ${caption}` : milestoneHeadline(event);
  const track = (action, properties = {}) => logEvent(celebrationEventName(event, action), { ...milestoneAnalytics(event), ...properties });
  const outcomes = {
    native_handoff: 'share_native_handoff', channel_intent: 'share_channel_clicked',
    copied: 'share_copied', downloaded: 'share_downloaded',
    cancelled: 'share_cancelled', error: 'share_error',
  };
  return (
    <div className={`${styles.celebration} ${styles[theme]} ${showShareOptions ? styles.sharing : ''}`}>
      <IconButton iconClassName="fa-solid fa-xmark" className={styles.closeButton}
        title="Chiudi" aria-label="Chiudi e continua a giocare"
        onClick={() => closeModal('header_close_button')} />
      <div className={styles.achievement}>
        <div className={styles.hero} aria-hidden="true">
          <FaIcon className={`${ICONS[theme]} ${styles.symbol}`} />
          {event.resource === 'streak' && <FaIcon className={`fa-solid fa-fire ${styles.innerFlame}`} />}
          {event.resource === 'stelline' && <span className={styles.starFacet} />}
        </div>
        <div className={styles.number} aria-hidden="true">{achievement}</div>
        <h3 id="global-modal-title" className={styles.headline} aria-label={headline}>{caption}</h3>
      </div>
      <div className={styles.brand}><img src="/gdp_logo_20260111.png" alt="Giochini di Parole" /></div>
      <div className={styles.actions}>
        <Share title={headline} text={shareText} copyText={shareText}
          url={milestoneShareUrl(event)} buttonLabel={MILESTONE_SHARE_LABEL}
          copyLabel="Copia traguardo" files={file ? [file] : []} downloadFile={file}
          fallbackPresentation="inline" className={styles.shareButton}
          replaceButtonOnFallback inlineFallbackHeading={MILESTONE_SHARE_LABEL}
          onFallbackOpen={() => setShowShareOptions(true)}
          onShareClick={() => track('share_clicked')}
          onShareOutcome={({ outcome, ...properties }) => track(outcomes[outcome], properties)} />
      </div>
    </div>
  );
};
export default MilestoneCelebration;
